import { createAsyncThunk } from "@reduxjs/toolkit";
import { admin_apiEndpoint, config_variable } from "../../helper/commonApi";
import { GetApiCall, ApiCall } from "../../helper/axios";

export const getUserOnboardingAsync = createAsyncThunk('fetch/getUserOnboarding', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/user-onboarding?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const createUserOnboardingAsync = createAsyncThunk('fetch/createUserOnboarding', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/user-onboarding?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    if (param.payload.isOnboardingCompleted) {
        await new Promise((res) =>
            setTimeout(() => {
                res();
            }, [1000])
        );
    }
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res.data.success, res.data.message);
        }
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const verifyAPIKeyAsync = createAsyncThunk('fetch/verifyAPIKey', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/verify-api-key?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    if (res?.data) {
        param.callback(res?.data?.success, res?.data?.message);
    }
    return res?.data;
});

export const createUserSubscriptionAsync = createAsyncThunk('fetch/createUserSubscription', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/create-user-subscription?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res.data.success);
        }
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

